import { atom } from 'recoil';

export const showFullPageAtom = atom({ key: 'showFullPageAtom', default: false });
